import React from "react";
import { Row, Col } from "react-bootstrap";
import Header from "../components/header.jsx";
import Team from "../containers/our-team.jsx";
import { useLocation } from "react-router-dom";
import mapImage from "../media/map-aboutUs.png"

const AboutUs = () => {
  const location = useLocation();
  return (
    <React.Fragment>
      <Header locationName={location.pathname} />
      {/* <LandingSlider /> */}
      <div className="about-banner-sec">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 d-flex flex-wrap justify-content-between align-items-center">
              <div className="col-lg-12">
                <div className="banner-content w-100">
                  <h3>About Us</h3>
                  <h6>Integrating Communities</h6>
                  <p>
                    "Providing the simplest solution for the most complex
                    problems"
                  </p>
                </div>
              </div>
              <div className="col-lg-7 py-5 d-none">
                {/* <div className="banner-img-area w-100">
                                    <img className="main-img" src="/media/bulb-animate.png" alt="" />
                                    <img className="left-img" src="/media/bulb-animate-left.png" alt="" /> 
                                    <img className="right-img" src="/media/bulb-animate-right.png" alt="" />
                                </div>  */}
                <div id="shape">
                  <div className="ft">
                    <a href="#!">UI/UX Designing</a>
                    {/* <p>We Offer Logo Designing, Web/App Designing and Mockup Designing.</p> */}
                  </div>
                  <div className="rt">
                    <a href="#!">Web/App Development</a>
                    {/* <p>We Offer Logo Designing, Web/App Designing and Mockup Designing.</p> */}
                  </div>
                  <div className="bk">
                    <a href="#!">SEO / Marketing</a>
                    {/* <p>We Offer Logo Designing, Web/App Designing and Mockup Designing.</p> */}
                  </div>
                  <div className="lt">
                    <a href="#!">IoT</a>
                    {/* <p>We Offer Logo Designing, Web/App Designing and Mockup Designing.</p> */}
                  </div>
                  <div className="tp">
                    <a href="#!">Quality Assurance</a>
                    {/* <p>We Offer Logo Designing, Web/App Designing and Mockup Designing.</p> */}
                  </div>
                  <div className="bm">
                    <a href="#!">DevOps</a>
                    {/* <p>We Offer Logo Designing, Web/App Designing and Mockup Designing.</p> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section id="about-us-sec">
        <div className="container-fluid px-0">
          {/* <Row className="m-0">
            <Col xs={12} lg={6} className="about-us-content">
              <h4 className="title-blue-bar ml-5 mt-3 mb-4">About Us</h4>
              <p className="mx-5 mb-4">
                Digital Landscape is an agile start-up technology company. We are a fast-growing, energetic, digital company that specializes in Digital Transformation, Business Consultancy & Advisory Services.
              </p>
              <p className="m-5">
                We help our clients design, build, and launch innovative digital products that help them engage their customers and keep them ahead of their competitors in an ever-evolving digital world.
              </p>
            </Col>
            <Col
              xs={12}
              lg={6}
              className="px-lg-0 d-flex justify-content-center align-items-center"
            >
              <img src="/media/about-us.webp" alt="" className="w-100 pt-3" />
            </Col>
          </Row> */}
          <Row className="mx-0 my-3">
            <Col xs={12} className="our-impact-content">
              <h4 className="title-blue-bar ml-5 mt-3 mb-4">
                Our External Auditors & Financial Consultants
              </h4>
              <div className="ml-5 mb-4 w-50">
                <div>
                  <img
                    src="/media/consultants-logo.png"
                    alt=""
                    style={{ width: "100%", paddingBottom: "20px" }}
                  />
                </div>
              </div>
              <div className="container mb-3 py-3 contact-div">
                <div className="row d-flex justify-content-center align-items-center">
                  {/* <div className="my-3 col-lg-3 col-10">
                    <div className="d-flex flex-direction-column justify-content-lg-center align-items-center contact-details">
                      <span className="mr-3">
                        <svg
                          width="30px"
                          height="30px"
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fas"
                          data-icon="map-marker-alt"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 384 512"
                          className="svg-inline--fa fa-map-marker-alt fa-w-12 fa-5x"
                        >
                          <path
                            fill="#53a4ef"
                            d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"
                            className=""
                          ></path>
                        </svg>
                      </span>
                      <p>
                        Office No. 12,13,14, 19, 20, 21 & 22, 2nd Floor, Al-Hamra
                        Centre, Shaheed-e-Millat Road Main Baloch Colony Stop,
                        Karachi, Pakistan.
                      </p>
                    </div>
                  </div> */}
                 
                  {/* <div className="my-3 col-lg-3 col-10">
                    <div className="d-flex flex-direction-column justify-content-lg-center align-items-center contact-details">
                      <span className="mr-3">
                        <svg
                          width="30px"
                          height="30px"
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fas"
                          data-icon="phone-alt"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 512 512"
                          className="svg-inline--fa fa-phone-alt fa-w-16 fa-5x"
                        >
                          <path
                            fill="#53a4ef"
                            d="M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"
                            className=""
                          ></path>
                        </svg>
                      </span>
                      <div>
                        <p className="mb-1">+92 343 0277578</p>
                        <p className="mb-1">+92 333 0343127</p>
                        <p>+92 334 0200347</p>
                      </div>
                    </div>
                  </div> */}
                  <div className="my-3 col-lg-3 col-10">
                    <div className="d-flex flex-direction-column justify-content-lg-center align-items-center contact-details">
                      <span className="mr-3">
                        <svg
                          width="30px"
                          height="30px"
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fas"
                          data-icon="envelope"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 512 512"
                          className="svg-inline--fa fa-envelope fa-w-16 fa-5x"
                        >
                          <path
                            fill="#53a4ef"
                            d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
                            className=""
                          ></path>
                        </svg>
                      </span>
                      <p className="mb-0">
                        <a href="mailto:mazhar.acma@gmail.com">
                          mazhar.acma@gmail.com
                        </a>
                      </p>
                    </div>
                  </div>
                  <div className="my-3 col-lg-3 col-10">
                    <div className="d-flex flex-direction-column justify-content-lg-center align-items-center contact-details">
                      <span className="d-inline-block mr-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="30"
                          viewBox="0 0 29.942 29.936"
                        >
                          <g transform="translate(0.505 0.5)">
                            <g transform="translate(0 0)">
                              <path
                                className="a"
                                stroke="#08a8f2"
                                d="M14.452.022A14.49,14.49,0,0,0,12.9.105a13.658,13.658,0,0,0-1.4.224l-.267.059a14.469,14.469,0,0,0-7.137,4q-.271.278-.531.573A14.485,14.485,0,0,0,24.811,24.63q.272-.278.531-.573A14.485,14.485,0,0,0,14.452.022ZM4.737,5.109c.076-.079.155-.155.233-.232s.179-.177.271-.263.164-.148.246-.221.186-.165.281-.245.17-.139.256-.208.193-.155.293-.229.177-.13.267-.193.2-.145.3-.211.183-.122.276-.181.207-.131.312-.193.189-.112.285-.166.214-.12.322-.178.193-.1.29-.151.221-.109.333-.162.2-.092.3-.135L9.345,2c.1-.041.2-.081.3-.12.117-.044.235-.086.353-.127.1-.035.2-.07.3-.1.12-.039.241-.074.363-.11.1-.029.2-.06.305-.087l.117-.028A11.981,11.981,0,0,0,8,6.43,16.218,16.218,0,0,1,4.694,5.157C4.71,5.14,4.723,5.123,4.737,5.109Zm-.694.777A16.776,16.776,0,0,0,7.707,7.344a25.056,25.056,0,0,0-.975,6.68H.943A13.49,13.49,0,0,1,4.043,5.886Zm0,17.242a13.492,13.492,0,0,1-3.1-8.138H6.732a25.053,25.053,0,0,0,.975,6.68A16.787,16.787,0,0,0,4.043,23.128Zm6.925,4.44c-.1-.025-.2-.056-.3-.086-.122-.036-.245-.071-.366-.111-.1-.033-.2-.068-.3-.1-.119-.041-.238-.083-.355-.128-.1-.038-.2-.078-.3-.119L9,26.877q-.148-.065-.294-.134c-.113-.053-.225-.107-.338-.163-.1-.048-.193-.1-.29-.149s-.217-.118-.325-.18-.188-.109-.281-.165-.211-.129-.315-.2-.183-.118-.274-.179-.2-.142-.306-.214S6.4,25.37,6.315,25.3s-.2-.153-.3-.231-.17-.136-.254-.206-.19-.164-.283-.247-.165-.145-.245-.219-.182-.175-.271-.264-.157-.153-.233-.231l-.042-.045A16.206,16.206,0,0,1,8,22.587,11.984,11.984,0,0,0,11.086,27.6C11.047,27.588,11.007,27.579,10.968,27.569Zm3,.42c-2.066-.294-3.877-2.45-5.017-5.634a24.537,24.537,0,0,1,5.017-.591Zm0-7.191a25.428,25.428,0,0,0-5.32.634A24.155,24.155,0,0,1,7.7,14.99h6.271V20.8Zm0-6.774H7.7a24.15,24.15,0,0,1,.951-6.443,25.436,25.436,0,0,0,5.32.634Zm0-6.774A24.512,24.512,0,0,1,8.952,6.66c1.14-3.184,2.951-5.341,5.017-5.634ZM24.86,5.886a13.492,13.492,0,0,1,3.1,8.138H22.171a25.053,25.053,0,0,0-.975-6.68A16.794,16.794,0,0,0,24.86,5.886ZM17.932,1.445c.1.025.2.057.3.086.122.036.245.071.366.111.1.033.2.068.3.1.119.041.238.083.355.128.1.038.2.078.3.119l.345.145q.148.065.294.134c.113.053.225.107.338.163.1.048.193.1.29.149s.217.118.325.18.188.109.281.165.211.129.315.2.183.118.274.179.2.141.305.214.177.127.265.193.2.153.3.231.17.135.254.206.19.164.283.247.165.145.245.219.182.175.271.264.157.153.233.231l.042.045A16.206,16.206,0,0,1,20.9,6.427a11.983,11.983,0,0,0-3.09-5.01C17.853,1.427,17.892,1.435,17.932,1.445Zm-3-.42c2.066.294,3.877,2.45,5.017,5.634a24.538,24.538,0,0,1-5.017.591V1.026Zm0,7.191a25.427,25.427,0,0,0,5.32-.634,24.155,24.155,0,0,1,.951,6.443H14.934Zm0,6.774h6.271a24.15,24.15,0,0,1-.951,6.443h0a25.436,25.436,0,0,0-5.32-.634Zm0,13V21.764a24.512,24.512,0,0,1,5.017.591C18.812,25.539,17,27.7,14.934,27.989Zm9.232-4.083c-.076.079-.155.155-.233.231s-.18.178-.272.264-.163.145-.245.22-.187.166-.282.246-.17.139-.256.207-.193.155-.293.229-.177.13-.267.193-.2.145-.3.211-.183.122-.276.181-.207.131-.312.193-.189.112-.284.166-.214.12-.323.178-.193.1-.29.151-.221.109-.333.162-.2.092-.3.135l-.343.145c-.1.041-.2.081-.3.119-.118.045-.236.087-.355.128-.1.035-.2.07-.3.1-.121.039-.241.075-.365.11-.1.03-.2.06-.3.087l-.117.028A11.981,11.981,0,0,0,20.9,22.584a16.217,16.217,0,0,1,3.308,1.273C24.194,23.874,24.18,23.891,24.166,23.906Zm.694-.777A16.776,16.776,0,0,0,21.2,21.67a25.056,25.056,0,0,0,.975-6.68H27.96A13.49,13.49,0,0,1,24.86,23.128Z"
                                transform="translate(0 -0.022)"
                              />
                            </g>
                          </g>
                        </svg>
                      </span>
                      <p className="mb-0">
                        <a href="https://www.pbck.pk" target="_blank">
                          www.pbck.pk
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="mx-0 my-3">
            <Col xs={12} className="our-impact-content">
              <h4 className="title-blue-bar ml-5 mt-3 mb-4">Our Impact</h4>
              <p className="mx-5 w-50">
                Human-centricity and co-creation are two core pillars of our
                culture
              </p>
            </Col>
          </Row>
          <Row className="m-0 p-5 our-impact-categories d-flex justify-content-lg-around justify-content-center align-items-center text-center">
            <div className="impact-cat m-2">
              <h2>3+</h2>
              <p>Years</p>
            </div>
            <div className="impact-cat m-2">
              <h2>13</h2>
              <p>Industries</p>
            </div>
            <div className="impact-cat m-2">
              <h2>25+</h2>
              <p>Employees</p>
            </div>
            <div className="impact-cat m-2">
              <h2>16</h2>
              <p>Brands</p>
            </div>
          </Row>
          {/* <Row className="m-0 our-impact-content">
                         <p className="mx-5 my-5 w-75">Human-centricity and co-creation are two core pillars of our culture. At Digital Lanscape, our employees choose to question, and are expected to question everything around them.</p>
                        <p className="mx-5 mb-4 w-75">The result?</p>
                        <p className="mx-5 w-75">Amazing people, great teams, awesome business units, and people-centric brands that always end up going to new and unknown places</p>
                        <p className="mx-5 mt-5 pt-5 w-100">We help our clients design, build, and launch innovative digital products that help them engage their customers and keep them ahead of their competitors in an ever-evolving operating landscape.</p>
                    </Row> */}
          <Row className="mx-0 my-3">
            <Col xs={12} className="our-industries-content">
              <h4 className="title-blue-bar ml-5 mt-3 mb-4">Our Industries</h4>
            </Col>
            <Col xs={12} className="our-industries-categories">
              <div className="container-fluid">
                <Row className="row1 d-flex justify-content-center text-center">
                  <div className="industry-cat industry-cat-light-blue d-flex flex-column justify-content-center align-items-center mx-5 my-3">
                    <img src="/media/industries-icons/icon1.png" alt="" />
                    <p>HealthCare</p>
                  </div>
                  <div className="industry-cat industry-cat-red d-flex flex-column justify-content-center align-items-center mx-5 my-3">
                    <img src="/media/industries-icons/icon2.png" alt="" />
                    <p>Education</p>
                  </div>
                  <div className="industry-cat industry-cat-light-green d-flex flex-column justify-content-center align-items-center mx-5 my-3">
                    <img src="/media/industries-icons/icon3.png" alt="" />
                    <p>Pharmaceutical</p>
                  </div>
                  <div className="industry-cat industry-cat-yellow d-flex flex-column justify-content-center align-items-center mx-5 my-3">
                    <img src="/media/industries-icons/icon4.png" alt="" />
                    <p>FMCG</p>
                  </div>
                </Row>
              </div>
            </Col>
            <Col xs={12} className="our-industries-categories">
              <div className="container-fluid">
                <Row className="row2 d-flex justify-content-center text-center">
                  <div className="industry-cat industry-cat-dark-blue d-flex flex-column justify-content-center align-items-center mx-5 my-3">
                    <img src="/media/industries-icons/icon5.png" alt="" />
                    <p>Manufacturing</p>
                  </div>
                  <div className="industry-cat industry-cat-light-green d-flex flex-column justify-content-center align-items-center mx-5 my-3">
                    <img src="/media/industries-icons/icon6.png" alt="" />
                    <p>Games Development</p>
                  </div>
                  <div className="industry-cat industry-cat-purple d-flex flex-column justify-content-center align-items-center mx-5 my-3">
                    <img src="/media/industries-icons/icon7.png" alt="" />
                    <p>Blockchain</p>
                  </div>
                  <div className="industry-cat industry-cat-maroon d-flex flex-column justify-content-center align-items-center mx-5 my-3">
                    <img src="/media/industries-icons/icon8.png" alt="" />
                    <p>Contact/Call Center</p>
                  </div>
                </Row>
              </div>
            </Col>
            <Col xs={12} className="our-industries-categories">
              <div className="container-fluid">
                <Row className="row3 d-flex justify-content-center text-center">
                  <div className="industry-cat industry-cat-dark-green d-flex flex-column justify-content-center align-items-center mx-5 my-3">
                    <img src="/media/industries-icons/icon9.png" alt="" />
                    <p>E-Commerce</p>
                  </div>
                  <div className="industry-cat industry-cat-light-green d-flex flex-column justify-content-center align-items-center mx-5 my-3">
                    <img src="/media/industries-icons/icon10.png" alt="" />
                    <p>Social Media</p>
                  </div>
                  <div className="industry-cat industry-cat-light-purple d-flex flex-column justify-content-center align-items-center mx-5 my-3">
                    <img src="/media/industries-icons/icon11.png" alt="" />
                    <p>Mixed Reality</p>
                  </div>
                  <div className="industry-cat industry-cat-light-green d-flex flex-column justify-content-center align-items-center mx-5 my-3">
                    <img src="/media/industries-icons/icon12.png" alt="" />
                    <p>3D Animated Videos</p>
                  </div>
                </Row>
              </div>
            </Col>
            <Col xs={12} className="our-industries-categories">
              <div className="container-fluid">
                <Row className="row5 d-flex justify-content-center align-items-center text-center">
                  <div className="industry-cat industry-cat-light-green mx-5 my-3">
                    <img src="/media/industries-icons/icon13.png" alt="" />
                    <p>Chat Bots</p>
                  </div>
                  <div className="industry-cat industry-cat-light-green mx-5 my-3">
                    <img src="/media/industries-icons/icon14.png" alt="" />
                    <p>Transportation & Retail</p>
                  </div>
                </Row>
              </div>
            </Col>
          </Row>
          
          <Row className="mx-0 my-3">
            <Col xs={12} className="our-industries-content">
              <h4 className="title-blue-bar ml-5 mt-3 mb-4">Cloud Security <span style={{fontSize : "16px", color : "#898585"}}>(Rapid Compute as a Partner)</span></h4>
            </Col>
            <Col xs={12} className="our-industries-categories">
              <div className="container-fluid">
                <Row className="d-flex justify-content-center align-items-center text-center">
                <div className="cloud-container">
                <h5>PCI-DSS Certificate</h5>
                  <img width={"550px"} src="/media/cloudSecurity/Certificate.png" alt=""  />
                </div>
                </Row>
              </div>
            </Col>
            <Col xs={12} className="our-industries-categories">
              <div className="container-fluid">
                <Row className="d-flex justify-content-center align-items-center text-center">
                <div className="cloud-container">
                <h5>ISO 27001:2013 Certificate</h5>
                  <img width="500px"  src="/media/cloudSecurity/ISO.png" alt=""  />
                </div>
                </Row>
              </div>
            </Col>
            <Col xs={12} className="our-industries-categories">
              <div className="container-fluid">
                <Row className="d-flex justify-content-center align-items-center text-center">
                <div className="cloud-container">
                <h5>Cloud Security Alliance</h5>
                  <img 
                      width = "510px"
                      height = {"530px"}
                  src="/media/cloudSecurity/Rapid.png" alt=""  />
                </div>
                </Row>
              </div>
            </Col>
            <Col xs={12} className="our-industries-categories">
              <div className="container-fluid">
                <Row className="d-flex justify-content-center align-items-center text-center">
                <div className="cloud-container">
                <h5>GDPR Compliance</h5>
                  <img 
                      width = "510px"
                      height = {"530px"} src="/media/cloudSecurity/GDPR.jpg" alt=""  />
                </div>
                </Row>
              </div>
            </Col>
            <Col xs={12} className="our-industries-categories">
              <div className="container-fluid">
                <Row className="d-flex justify-content-center align-items-center text-center">
                <div className="cloud-container">
                <h5>IS0 27017 - 1</h5>
                  <img 
                      width = "510px"
                      height = {"530px"} src="/media/cloudSecurity/IS0 27017-1.jpg" alt=""  />
                </div>
                </Row>
              </div>
            </Col>
            <Col xs={12} className="our-industries-categories">
              <div className="container-fluid">
                <Row className="d-flex justify-content-center align-items-center text-center">
                <div className="cloud-container">
                <h5>IS0 27017 - 2</h5>
                  <img 
                      width = "510px"
                      height = {"530px"} src="/media/cloudSecurity/IS0 27017-2.jpg" alt=""  />
                </div>
                </Row>
              </div>
            </Col>
            <Col xs={12} className="our-industries-categories">
              <div className="container-fluid">
                <Row className="d-flex justify-content-center align-items-center text-center">
                <div className="cloud-container">
                <h5>IS0 27001 - 1</h5>
                  <img 
                      width = "510px"
                      height = {"530px"} src="/media/cloudSecurity/ISO 27001-1.jpg" alt=""  />
                </div>
                </Row>
              </div>
            </Col>
            <Col xs={12} className="our-industries-categories">
              <div className="container-fluid">
                <Row className="d-flex justify-content-center align-items-center text-center">
                <div className="cloud-container">
                <h5>IS0 27001-2</h5>
                  <img 
                      width = "510px"
                      height = {"530px"} src="/media/cloudSecurity/ISO 27001-2.jpg" alt=""  />
                </div>
                </Row>
              </div>
            </Col>
            <Col xs={12} className="our-industries-categories">
              <div className="container-fluid">
                <Row className="d-flex justify-content-center align-items-center text-center">
                <div className="cloud-container">
                <h5>IS0 27018-1</h5>
                  <img 
                      width = "510px"
                      height = {"530px"} src="/media/cloudSecurity/ISO 27018-1.jpg" alt=""  />
                </div>
                </Row>
              </div>
            </Col>
            <Col xs={12} className="our-industries-categories">
              <div className="container-fluid">
                <Row className="d-flex justify-content-center align-items-center text-center">
                <div className="cloud-container">
                <h5>IS0 27018-2</h5>
                  <img 
                      width = "510px"
                      height = {"530px"} src="/media/cloudSecurity/ISO 27018-2.jpg" alt=""  />
                </div>
                </Row>
              </div>
            </Col>
            <Col xs={12} className="our-industries-categories">
              <div className="container-fluid">
                <Row className="d-flex justify-content-center align-items-center text-center">
                <div className="cloud-container">
                <h5>PCI DSS v3.2.1 Certificate</h5>
                  <img 
                      width = "510px"
                      height = {"530px"} src="/media/cloudSecurity/PCI DSS v3.2.1 Certificate 2022.jpg" alt=""  />
                </div>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
        {/* <Team /> */}
        <div style={{marginTop : "20px"}}>
          <Col xs={12}>
            <h4 className="title-blue-bar ml-5 mt-3 mb-4">Where We Are</h4>
            <p className="overview-black ml-5">Solutions That Span the Globe</p>
          </Col>
          <img alt="google-map" src={mapImage} width="100%" height="600"/>
        </div>
        {/* <Rfq/> */}
      </section>
      {/* <Footer /> */}
    </React.Fragment>
  );
};

export default AboutUs;
